import { Topbar } from '@layouts/Admin/Topbar'

interface EmbedProps {
	children: React.ReactNode
}

export function EmbedLayout({ children }: EmbedProps) {
	return (
		<div
			className={'w-full flex flex-col justify-center items-center bg-zinc-950'}
		>
			<Topbar />
			<div className='w-full h-svh max-h-[calc(100vh_-_90px)] overflow-clip'>
				{children}
			</div>
		</div>
	)
}
